export default __webpack_public_path__ + "static/media/omocom.bf72791e.png";